<template>
  <div
    v-if="!$register"
    class="q-mt-sm seat-progress-bar bg-grey-5 q-mx-xs"
  >
    <div
      :class="'bg-' + availableColor(showing)"
      :style="{ width: (showing.ticketsSold / (showing.screen.seatCount - showing.heldSeatCount) * 100) + '%' }"
    />
    <div
      class="bg-grey-4"
      :style="{ width: (showing.seatsRemaining / (showing.screen.seatCount - showing.heldSeatCount) * 100) + '%' }"
    />
  </div>
  <div
    v-else
    class="q-mt-sm seat-progress-bar bg-grey-5 q-mx-xs"
    @click="$emit('click')"
  >
    <div
      class="bg-primary"
      :style="{ width: (showing.ticketsSold / showing.screen.seatCount * 100) + '%' }"
    />
    <div
      :class="'bg-' + availableColor(showing)"
      :style="{ width: (showing.seatsRemaining / showing.screen.seatCount * 100) + '%' }"
    />
    <div
      v-if="showing.reservedSeating && socialDistanceCount(showing)"
      class="bg-grey-4"
      :style="{ width: (socialDistanceCount(showing) / showing.screen.seatCount * 100) + '%' }"
    />
    <div
      v-if="showing.reservedSeating"
      class="bg-grey-5"
      :style="{ width: (showing.unavailableCount / showing.screen.seatCount * 100) + '%' }"
    />
    <div
      v-if="currentSite.showAttendancePredictionInPos"
      class="absolute"
      style="width: 0; border-left: 1px dotted;"
      :style="{ left: (showing.predictedAttendance / showing.screen.seatCount * 100) + '%' }"
    />
    <div
      v-else
      class="bg-grey-5"
      :style="{ width: (showing.heldSeatCount / showing.screen.seatCount * 100) + '%' }"
    />
  </div>
</template>

<script>

export default {
  name: 'ShowtimeAttendanceBar',
  props: {
    showing: {
      type: Object,
      required: true
    }
  },
  configuration: ['currentSite'],
  emits: ['click'],
  methods: {
    availableColor (showing) {
      const ratio = showing.seatsRemaining / (showing.screen.seatCount - showing.heldSeatCount)
      if (this.$register) {
        if (ratio < 0.25) {
          return 'red-3'
        } else if (ratio < 0.5) {
          return 'yellow-3'
        } else {
          return 'green-3'
        }
      } else {
        if (ratio < 0.05) {
          return 'red-6'
        } else if (ratio < 0.25) {
          return 'yellow-6'
        } else {
          return 'green-6'
        }
      }
    },
    socialDistanceCount (showing) {
      return showing.seatsRemainingWithoutSocialDistancing - showing.seatsRemaining
    },
    unavailableCount (showing) {
      return showing.screen.seatCount - showing.seatsRemaining
    }
  }
}
</script>

<style lang="scss" scoped>
.seat-progress-bar {
  position: relative;
  border: solid 1px #CCC;
  height: 8px;
  border-radius: 10px;
  overflow: hidden;
  text-align: left;
}
.seat-progress-bar > div {
  display: inline-block;
  height: 15px;
}
</style>
